var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 47c0 25.957-21.043 47-47 47S0 72.957 0 47 21.043 0 47 0s47 21.043 47 47Z",
    fill: "#C0D4C0",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.37 47 34.815 68.105v-42.21L71.37 47Z",
    fill: "#000"
  })));
};

export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgOTQgOTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05NCA0N0M5NCA3Mi45NTc0IDcyLjk1NzQgOTQgNDcgOTRDMjEuMDQyNiA5NCAwIDcyLjk1NzQgMCA0N0MwIDIxLjA0MjYgMjEuMDQyNiAwIDQ3IDBDNzIuOTU3NCAwIDk0IDIxLjA0MjYgOTQgNDdaIiBmaWxsPSIjQzBENEMwIiBmaWxsLW9wYWNpdHk9IjAuOCIvPgo8cGF0aCBkPSJNNzEuMzcwNCA0N0wzNC44MTQ4IDY4LjEwNTRMMzQuODE0OCAyNS44OTQ2TDcxLjM3MDQgNDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";